import React,{Fragment} from 'react'

export default function PartVideo(props) {
    let part = props.part;
    let video_id = part['video'];

    return (
        <Fragment>
            { getVideo(part, video_id) }
        </Fragment>

    )
}


function getVideo(part, video_id) {
    switch (part['layout']) {
        case 'embed':
            return (
                <div className="text">
                    <div dangerouslySetInnerHTML={{__html: part['content']}} />
                    <iframe id="player" src={`https://www.youtube.com/embed/${video_id}?enablejsapi=1`} frameborder="0" title="video"></iframe>
                </div>
            )
        case 'fullscreen':
            return (
                <Fragment>
                    <div className="text">
                        <div dangerouslySetInnerHTML={{__html: part['content']}} />
                        <div className="play-button" data-video={video_id}>
                            <i className="play fa fa-play-circle" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div className="gallery video">
                        <div className="show-button"></div>
                        <div className="viewport video">
                            <div className="close-button">
                                <div className="text">
                                    <p className="close">Cerrar</p>
                                </div>
                                <div className="button_"><span className="lines"></span></div>
                            </div>
                            <div className="images no-thumbs">
                                <iframe id="player" width="100%" height="100%" src={`https://www.youtube.com/embed/${video_id}?enablejsapi=1`} frameborder="0" title="video"></iframe>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        default:
            return null
    }
}

